import { useCallback, useMemo, useState } from 'react';
import { useStore, useToast } from 'hooks';

const useBarManagerKegData = () => {
  const { errorToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { itemsStore } = useStore();
  const loadData = useCallback(async () => {
    try {
      setIsLoading(true);
      await Promise.all([itemsStore.fetchAllItems()]);
    } catch (err) {
      errorToast(err);
    } finally {
      setIsLoading(false);
    }
  }, [errorToast, itemsStore]);

  const isLoaded = useMemo(() => {
    return itemsStore.isLoaded;
  }, [itemsStore.isLoaded]);

  return { isLoading, isLoaded, loadData };
};

export default useBarManagerKegData;
